import { FormattedMessage, useIntl } from "react-intl";
import OffScreen from "../../../../../common/core-ui/OffScreen.tsx";
import MiscellaneousDownload from "../../../../../common/icons/MiscellaneousDownload.tsx";
import { clsx } from "clsx";
import styles from "./Attachments.module.scss";
import { Attachment } from "common/api/decimal/methods/course.ts";

export default function Attachments({
  attachments,
}: {
  attachments: Attachment[];
}) {
  const intl = useIntl();

  function getTypeProps(attachment: Attachment) {
    const filename = attachment.filename;
    return {
      filename,
      icon: <MiscellaneousDownload />,
      type: intl.formatMessage({ defaultMessage: "File" }),
      tooltip: intl.formatMessage({ defaultMessage: "Download" }),
      label: intl.formatMessage(
        { defaultMessage: "Download {attachment}" },
        { attachment: filename }
      ),
    };
  }

  const transformedAttachments = attachments.map((attachment) => {
    return {
      ...attachment,
      ...getTypeProps(attachment),
    };
  });

  return (
    <table className={clsx("vst-table", "vst-table-size-small", styles.table)}>
      <thead>
        <tr>
          <th>
            <FormattedMessage defaultMessage="Attachments" />
          </th>
          <th>
            <OffScreen>
              <FormattedMessage defaultMessage="Link" />
            </OffScreen>
          </th>
        </tr>
      </thead>
      <tbody>
        {transformedAttachments.map((attachment) => (
          <tr key={attachment.url}>
            <td>{attachment.filename}</td>
            <td>
              <a
                rel="noopener noreferrer"
                href={attachment.url}
                target="_blank"
                aria-label={attachment.label}
                data-tooltip-content={attachment.tooltip}
                className={clsx(
                  "vst-icon-button-circle",
                  "vst-icon-button-size-small",
                  "vst-icon-button-option-negative-margin",
                  "vst-icon-button-option-compact"
                )}
              >
                {attachment.icon}
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
